interface PresignedPostData {
  url: string
  fields: {
    [key: string]: string
  }
}

function isPresignedPostData(data: object): data is PresignedPostData {
  return 'fields' in data
}

function parse(data: unknown): object {
  if (typeof data === 'string') return JSON.parse(data)
  if (typeof data === 'object' && !!data) return data
  throw "Can't parse presignedPostData"
}

export function uploadToS3(
  file: File,
  postData: string,
  onProgress?: (progress: number) => void
) {
  const formData = new FormData()
  const data = parse(postData)

  if (!isPresignedPostData(data)) throw "Can't parse presignedPostData"

  Object.keys(data.fields).forEach(key => {
    formData.append(key, data.fields[key])
  })

  formData.append('Content-Type', file.type)
  formData.append('file', file, file.name)

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.responseType = 'json'

    xhr.upload.onprogress = event => {
      onProgress?.(Math.round((event.loaded / event.total) * 100))
    }

    xhr.upload.onloadstart = () => onProgress?.(0)
    xhr.upload.onloadend = () => onProgress?.(100)

    xhr.onreadystatechange = () => {
      // Not finished yet
      if (xhr.status === 0) return

      if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.response)
      else reject(xhr.response)
    }

    xhr.onerror = error => {
      console.error('Error uploading file', error)

      reject(error)
    }

    xhr.onabort = event => {
      console.error('Upload aborted', event)

      reject(event)
    }

    xhr.open('POST', data.url, true)

    xhr.send(formData)
  })
}
